import type { RootState } from '@/app/store';

export const selectProductionReportData = (state: RootState) =>
  state.productionReport.reportData;
export const selectProductionReportLoading = (state: RootState) =>
  state.productionReport.fetchReportLoading;
export const selectProductionReportError = (state: RootState) =>
  state.productionReport.fetchReportError;
export const selectProductionReportResponse = (state: RootState) =>
  state.productionReport.reportingResponse;
export const selectProductionReportReporting = (state: RootState) =>
  state.productionReport.isSubmittingReport;
export const selectProductionReportReportingError = (state: RootState) =>
  state.productionReport.reportingError;
